export function toggleInList<T extends string>(list: T[], value: T): T[] {
  return list.includes(value) ? list.filter((x) => x !== value) : [...list, value]
}

export function FilterChip({
  label,
  active,
  onClick,
  tone = 'neutral',
  swatchColor,
}: {
  label: string
  active: boolean
  onClick: () => void
  tone?: 'neutral' | 'error' | 'warning' | 'success'
  swatchColor?: string
}) {
  const activeTone =
    tone === 'error'
      ? 'badge-error'
      : tone === 'warning'
        ? 'badge-warning'
        : tone === 'success'
          ? 'badge-success'
          : 'badge-primary'

  return (
    <button
      type="button"
      className={`badge badge-sm cursor-pointer border transition-colors gap-1 ${
        active ? `${activeTone} border-transparent` : 'badge-ghost border-base-300 hover:border-base-content/30'
      }`}
      aria-pressed={active}
      onClick={onClick}
    >
      {swatchColor ? (
        <span
          className="h-2 w-2 shrink-0 rounded-full border border-black/20"
          style={{ backgroundColor: swatchColor }}
          aria-hidden
        />
      ) : null}
      {label}
    </button>
  )
}

